export default "__VITE_ASSET__D2VZXcHD__"